import Vue from 'vue'
import { login, getInfo, logout } from '@/api/login'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { welcome } from '@/utils/util'

const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    }
  },

  actions: {
    // 用户名登录
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo.username, userInfo.password, userInfo.code, userInfo.t).then(response => {
          // Vue.ls.set(ACCESS_TOKEN, response.access_token)
          // commit('SET_TOKEN', response.access_token)
          // resolve()
          if (response.access_token){
            Vue.ls.set(ACCESS_TOKEN, response.access_token)
            commit('SET_TOKEN', response.access_token)
            response.code = 200;
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const result = response.data;
          if (result.permissions.length > 0){
            commit('SET_ROLES', result.permissions)
            commit('SET_INFO', result)
            window.sessionStorage["user_deptId"] = result.deptId;
          }else {
            reject(new Error('getInfo: roles must be a non-null array !'))
          }
          // commit('SET_INFO', result)

          commit('SET_NAME', { name: result.name, welcome: welcome() })
          commit('SET_AVATAR', result.avatar)

          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout ({ commit, state }) {
      return new Promise((resolve) => {
        logout(state.token).then(() => {
          resolve()
        }).catch(() => {
          resolve()
        }).finally(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          window.sessionStorage.removeItem("user_deptId");
          Vue.ls.remove(ACCESS_TOKEN)
        })
      })
    }

  }
}

export default user
